import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";
import { getErrorMessage } from '@/utils/errorUtils';
import { AxiosError } from "axios";

export interface OrgInvitationRequest {
  email: string;
  memberRole: string;
}

export interface OrgInvitationResponse {
  success?: boolean;
  message?: string;
  data?: unknown;
}

export interface OrganizationRequestResponse {
  success?: boolean;
  message?: string;
  data?: unknown;
}

export const inviteOrganizationMember = async (
  payload: OrgInvitationRequest
): Promise<OrgInvitationResponse> => {
  try {
    const response = await apiClient.post<OrgInvitationResponse>(
      ENDPOINTS.ORG.INVITATIONS,
      payload
    );
    return response.data;
  } catch (error: unknown) {
    const errorMessage =
      getErrorMessage(error) ||
      (error as AxiosError).message ||
      "Failed to send organization invitation";
    throw new Error(errorMessage);
  }
};

export const requestOrganizationAccess = async (): Promise<OrganizationRequestResponse> => {
  try {
    const response = await apiClient.post<OrganizationRequestResponse>(
      ENDPOINTS.OPERATOR.ORGANIZATION_REQUEST,
      {}
    );
    return response.data;
  } catch (error: unknown) {
    const errorMessage =
      getErrorMessage(error) ||
      (error as AxiosError).message ||
      "Failed to send organization request";
    throw new Error(errorMessage);
  }
};

export const requestCountryManagerAccess = async (
  payload: { country: string }
): Promise<OrganizationRequestResponse> => {
  try {
    const response = await apiClient.post<OrganizationRequestResponse>(
      ENDPOINTS.OPERATOR.COUNTRY_MANAGER_REQUEST,
      payload
    );
    return response.data;
  } catch (error: unknown) {
    const errorMessage =
      getErrorMessage(error) ||
      (error as AxiosError).message ||
      "Failed to send country manager request";
    throw new Error(errorMessage);
  }
};

export default {
  inviteOrganizationMember,
  requestOrganizationAccess,
  requestCountryManagerAccess,
};
